export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const RESET_FORM_FIELDS = "RESET_FORM_FIELDS";
export const SET_CRUD_FROM_FIELDS = "SET_CRUD_FROM_FIELDS";
export const SET_SELECTED_MENU = "SET_SELECTED_MENU";
export const SET_CRUD_SEARCH_FIELDS = "SET_CRUD_SEARCH_FIELDS";
export const RESET_SEARCH_FIELDS = "RESET_SEARCH_FIELDS";
